<template>
  <div class="w-100">
    <div :class="`${bgColor} px-3 border-bottom`" v-for="(product,product_i) in products">
      <div class="row no-gutters py-3">
        <div class="col-7 text-left">
          <p class="mb-0 body-2 text-12 text-truncate">{{product.name}}</p>
          <p class="mb-0 body-2-2 font-semibold text-12">{{product.module}}</p>
          <p class="mb-0 body-3" v-if="$isNotEmpty(product.other)">{{ product.other }}</p>
        </div>
        <div class="col-5 text-right">
          <p class="mb-0 body-2-2 text-12 font-semibold">{{ product.price}}</p>
          <p class="mb-0 body-2-2 text-12">{{product.qty}} {{ product.unit ? product.unit : 'x' }}</p>
          <p class="mb-0 body-2-2 text-10 text-orange underline cursor-pointer" @click="removeProduct(product)">{{$t('hotel.remove')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['products','bgColor'],
    methods:{
      removeProduct(product){
        this.$emit('removeProduct', product)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ProductCartLightStyle.vue